import AchatsModuleLayout from '@features/achats/components/AchatsModuleLayout'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'
import { createFileRoute } from '@tanstack/react-router'
import { ShoppingCart } from 'lucide-react'

/**
 * Achats Module Route
 *
 * Layout wrapper for the Achats feature.
 * Permission checks are defined per-feature in child routes.
 */
export const Route = createFileRoute('/_app/achats')({
  staticData: {
    title: 'Achats',
    icon: ShoppingCart,
    permission: PERMISSIONS.ACHATS.FOURNISSEURS.VIEW,
    module: 'achats',
    section: 'Achats',
    order: 30,
    showInNav: false,
  },
  component: AchatsModuleLayout,
})
